import { Grid, Typography, Checkbox } from '@ts/storybook';
import { FLAVORS } from '@ts/ui-models';

interface FlavorSelectProps {
  selectedFlavors?: string[];
  lockedFlavors?: string[];
  addFlavor: (flavorName: string) => void;
  removeFlavor: (flavorName: string) => void;
  isReadOnly?: boolean;
}

const FlavorSelect = ({
  selectedFlavors = [],
  lockedFlavors = [],
  addFlavor,
  removeFlavor,
  isReadOnly = false,
}: FlavorSelectProps) => {
  const toggleFlavor = (flavorName: string, value: boolean) => {
    value ? addFlavor(flavorName) : removeFlavor(flavorName);
  };

  const isChecked = (flavorName: string) => {
    return selectedFlavors.includes(flavorName);
  };

  const isLocked = (flavorName: string) => {
    return lockedFlavors.includes(flavorName) || (selectedFlavors.length <= 1 && selectedFlavors.some(flv => flv === flavorName));
  };

  return (
    <Grid container id="grid-flavor-select" spacing={2}>
      <Grid>
        <Typography className="pt-3 mr-4" text={['Flavors', ': ']} />
      </Grid>
      {FLAVORS.map(flavor => (
        <Grid size={{ xs: 'auto' }} key={flavor.name}>
          <Checkbox
            id={flavor.name}
            label={flavor.label}
            checked={isChecked(flavor.name)}
            onChangeValue={isReadOnly ? () => {} : v => toggleFlavor(flavor.name, v)}
            disabled={isLocked(flavor.name)}
            isReadOnly={isReadOnly}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default FlavorSelect;
